import { createGlobalStyle } from 'styled-components';
import AvenirMediumWoff from '@/assets/fonts/Avenir-Medium.woff';
import AvenirMediumWoff2 from '@/assets/fonts/Avenir-Medium.woff2';
import SophiaProMediumWoff from '@/assets/fonts/SofiaPro-Medium.woff';
import SophiaProMediumWoff2 from '@/assets/fonts/SofiaPro-Medium.woff2';
import SophiaProRegularWoff from '@/assets/fonts/SofiaProRegular.woff';
import SophiaProRegularWoff2 from '@/assets/fonts/SofiaProRegular.woff2';
import NotoSansWoff from '@/assets/fonts/NotoSansRegular.woff';
import NotoSansWoff2 from '@/assets/fonts/NotoSansRegular.woff2';
export const GlobalStyle = createGlobalStyle `
  * {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  ::-webkit-selection {
    background: transparent;
    color: inherit;
  }

  body {
    transition-duration: unset;
    overscroll-behavior-y: none;
    font-family: 'Sofia Pro Regular', 'Noto Sans', sans-serif;
  }

  @font-face {
    font-family: 'Avenir Medium';
    src: local('Avenir Medium'),
    url(${AvenirMediumWoff2}) format('woff2'),
    url(${AvenirMediumWoff}) format('woff');
    font-weight: 500;
    font-style: normal;
  }

  @font-face {
    font-family: 'Sophia Pro Medium';
    src: local('Sophia Pro Medium'),
    url(${SophiaProMediumWoff2}) format('woff2'),
    url(${SophiaProMediumWoff}) format('woff');
    font-weight: 500;
    font-style: normal;
  }

  @font-face {
    font-family: 'Sofia Pro Regular';
    src: local('Sofia Pro Regular'),
    url(${SophiaProRegularWoff2}) format('woff2'),
    url(${SophiaProRegularWoff}) format('woff');
    font-weight: 400;
    font-style: normal;
  }

  @font-face {
    font-family: 'Noto Sans';
    src: local('Noto Sans'),
    url(${NotoSansWoff2}) format('woff2'),
    url(${NotoSansWoff}) format('woff');
    font-weight: 400;
    font-style: normal;
  }

  html[dir='rtl'] {
    svg[class^='icon-'] {
      transform: scaleX(-1);
    }

    input {
      text-align: right;
    }

    .chakra-select__icon-wrapper {
      right: auto;
      left: 0.5rem;
    }

    .chakra-input__left-element {
      left: auto;
      right: 0;
    }

    .chakra-input__right-element {
      right: auto;
      left: 0;
    }

    .chakra-popover__popper {
      inset: 0 0 auto auto !important;
    }

    .react-datepicker-popper {
      inset: 0 0 auto auto !important;
    }
  }

  .chakra-checkbox__control[data-disabled] {
    background-color: var(--chakra-colors-darkBrandBlue-5) !important;
  }

  /* Reset list styles by levels */
  ul > li {
    list-style-type: initial;
  }

  ul > li > ul > li {
    list-style-type: circle;
  }

  ul ul ul li {
    list-style-type: square;
  }

  .chakra-toast__inner {
    min-width: 100% !important;
    margin: 0 !important;
  }

  /* Prevent required fields to display asterisk (*) */
  .chakra-form__required-indicator {
    display: none !important;
  }

  .numeric-rating-scale > :first-of-type > div {
    border-radius: 8px 0 0 8px;
  }

  .numeric-rating-scale > :last-of-type > div {
    border-radius: 0 8px 8px 0;
  }

  [dir="ltr"] .numeric-rating-scale > :first-of-type > div {
    border-radius: 8px 0 0 8px;
  }

  [dir="ltr"] .numeric-rating-scale > :last-of-type > div {
    border-radius: 0 8px 8px 0;
  }

  [dir="rtl"] .numeric-rating-scale > :first-of-type > div {
    border-radius: 0 8px 8px 0;
  }

  [dir="rtl"] .numeric-rating-scale > :last-of-type > div {
    border-radius: 8px 0 0 8px;
  }

  .numeric-rating-scale-labels p:only-child:is(p):is(:only-child) div p {
    text-align: center;
  }

  [dir="ltr"] .numeric-rating-scale-labels p:first-child div p{
    text-align: left;
  }

  [dir="ltr"] .numeric-rating-scale-labels p:last-child div p{
    text-align: right;
  }

  [dir="rtl"] .numeric-rating-scale-labels p:first-child div p{
    text-align: right;
  }

  [dir="rtl"] .numeric-rating-scale-labels p:last-child div p{
    text-align: left;
  }

  .fill-width {
    width: 100vw;
  }

  @media only screen and (max-width: 820px) {
    .fill-width.ignore-horizontal-padding {
      width: 100vw;
      margin-left: calc(50% - 50vw);
      margin-right: calc(50% - 50vw);

      img {
        border-radius: 0;
      }
    }
  }
`;
